angular.module('natura').directive('pggSearch', [function () {
  return {
    restrict: "E",
    templateUrl: "assets/terkep/app/search/search.html",
    replace: true,
    scope: {
      map: "="
    },
    controller: "PggSearchController",
    controllerAs: "ctrl",
    bindToController: true
  };
}]);

angular.module('natura').provider(
  "pggSearchProvider", [function () {

    /**
     * CONFIG
     */
    var config = {
      baseUrl: null,
      searchables: null
    };

    this.$get = [
      '$http',
      '$sce',
      'pggConfigProvider',
      'pggJstsProvider',
      function ($http, $sce, pggConfigProvider, pggJstsProvider) {
        /**
         * GETTERS AND SETTERS
         */
        var _getConfig = function() {
          return config;
        };
        var _getSearchables = function () {
          return config.searchables;
        };
        var _setSearchables = function (searchables) {
          config.searchables = searchables;
        };
        /**
         * FUNCTIONS
         */
        var _getTelepulesPromise = function () {
          var promise = $http.get(pggConfigProvider.getBaseUrl() + "/q/telepules").then(function (response) {
            return response;
          });
          return promise;
        };

        var _getGazdalkodasiteruletPromise = function () {
          var promise = $http.get(pggConfigProvider.getBaseUrl() + "/gis/gazdalkodasi-terulet", {
            headers: {
              'X-CSRF-TOKEN': pggConfigProvider.getCsrfToken()
            }
          }).then(function (response) {
            return response;
          });
          return promise;
        };

        var _createOptionForGazdalkodoi = function (feature) {
          var geom = pggJstsProvider.getConfig().ol3Parser.read(feature.getGeometry());
          var envelope = geom.getEnvelopeInternal();
          var minx = envelope.getMinX();
          var miny = envelope.getMinY();
          var maxx = envelope.getMaxX();
          var maxy = envelope.getMaxY();
          var name = feature.getProperties().name === null ? "" : feature.getProperties().name;
          return {
            type: 'gazdalkodoi',
            id: feature.getProperties().id,
            value: name + " (gazdálkodói terület)",
            bbox: [minx, miny, maxx, maxy],
            center: [(minx + maxx) / 2, (miny + maxy) / 2]
          };
        };

        var _createOptionForTelepules = function (telepules) {
          return {
            type: 'telepules',
            id: telepules.id,
            value: telepules.name,
            bbox: [telepules.bbox.minx, telepules.bbox.miny, telepules.bbox.maxx, telepules.bbox.maxy],
            center: [telepules.centroid.lat, telepules.centroid.lng]
          };
        };

        var _updateOptionForGazdalkodoiByFeature = function (feature) {
          for (var i = 0; i < config.searchables.length; i++) {
            if (config.searchables[i].type == "gazdalkodoi" &&
              config.searchables[i].id == feature.getProperties().id) {
              config.searchables[i] = _createOptionForGazdalkodoi(feature);
            }
          }
        };

        var _deleteOptionForGazdalkodoiById = function (id) {
          for (var i = 0; i < config.searchables.length; i++) {
            if (config.searchables[i].type == "gazdalkodoi" && config.searchables[i].id == id) {
              config.searchables.splice(i, 1);
            }
          }
        };

        var _pushOptionToSearchables = function (obj) {
          config.searchables.push(obj);
        };

        /**
         * RETURNS
         */
        return {
          getConfig: _getConfig,
          getSearchables: _getSearchables,
          setSearchables: _setSearchables,
          getTelepulesPromise: _getTelepulesPromise,
          getGazdalkodasiteruletPromise: _getGazdalkodasiteruletPromise,
          createOptionForGazdalkodoi: _createOptionForGazdalkodoi,
          createOptionForTelepules: _createOptionForTelepules,
          updateOptionForGazdalkodoiByFeature: _updateOptionForGazdalkodoiByFeature,
          deleteOptionForGazdalkodoiById: _deleteOptionForGazdalkodoiById,
          pushOptionToSearchables: _pushOptionToSearchables
        };
      }
    ];
  }]);

angular.module('natura').controller(
  'PggSearchController', ['$scope', '$log', '$sce', 'pggSearchProvider', 'pggConfigProvider', 'pggEditProvider', 'pggJstsProvider',
    function ($scope, $log, $sce, pggSearchProvider, pggConfigProvider, pggEditProvider, pggJstsProvider) {
      $scope.map = this.map;
      $scope.selected = undefined;
      $scope.searchables = [];

      $scope.startsWith = function (state, viewValue) {
        if (isNaN(state) && state !== "gazdalkodoi" && typeof state !== "object") {
          return state.substring(0, viewValue.length).toLowerCase() == viewValue.toLowerCase();
        } else {
          return false;
        }
      };

      pggSearchProvider.setSearchables($scope.searchables);

      /**
       * Gazdálkodási területek lekérdezése webservice-ből, ha az user
       * bejelentkezett már (userId !== 0) és a gazdálkodói modulon van
       */
      if (pggEditProvider.getUserId() !== 0 && window.location.pathname == "/gazdalkodoi-modul") {
        pggSearchProvider.getGazdalkodasiteruletPromise().then(function (data) {
          if (data.status == 200 && data.statusText == "OK" && data.data.errors === null) {
            if (data.data.hasOwnProperty("geojson") && data.data.geojson.hasOwnProperty("features")) {
              angular.forEach(data.data.geojson.features, function (terulet) {
                var feature = new ol.format.GeoJSON().readFeatures(terulet)[0];
                var option = pggSearchProvider.createOptionForGazdalkodoi(feature);
                pggSearchProvider.pushOptionToSearchables(option);
              });
            } else {
              $log.error("Hiba a gazdálkodási terület geometria lekérdezésnél");
              $log.error(data);
            }
          } else {
            $log.error("Hiba a gazdálkodási terület lekérdezésnél");
            $log.error(data);
          }
        });
      }

      /**
       * Települések lekérdezése webservice-ből
       */
      pggSearchProvider.getTelepulesPromise().then(function (data) {
        if (data.status == 200 && data.statusText == "OK") {
          angular.forEach(data.data, function (telepules) {
            pggSearchProvider.pushOptionToSearchables(pggSearchProvider.createOptionForTelepules(telepules));
          });
        } else {
          $log.error("Hiba a település lekérdezésnél");
          $log.error(data);
        }
      });

      /**
       * Elem kijelölés esemény: navigáljon a térkép az adott bbox-ra
       */
      $scope.onSelect = function ($item, $model, $label) {
        $scope.map.getView().fit($item.bbox, $scope.map.getSize());
        $scope.selected = undefined;
      };

    }
  ]);
